import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { HeartCrack } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-16">
        <Card className="p-8 rounded-3xl border-[#E8DEC8] bg-white text-center" data-testid="payment-cancel-card">
          <div className="w-14 h-14 mx-auto rounded-full bg-[#F9F5EE] flex items-center justify-center mb-3">
            <HeartCrack className="w-7 h-7 text-[#6E655F]" />
          </div>
          <h1 className="font-serif text-3xl font-bold text-[#2C2623] mb-2">No worries — you cancelled</h1>
          <p className="text-[#6E655F] mb-6">
            No charge was made. HerpMates stays free to use forever.
          </p>
          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate("/premium")}
              data-testid="payment-cancel-back-btn"
              className="rounded-full bg-[#D95D39] hover:bg-[#C24C29] h-11">
              Back to Premium
            </Button>
            <Button variant="outline" onClick={() => navigate("/discover")}
              data-testid="payment-cancel-discover-btn"
              className="rounded-full h-11">Keep exploring</Button>
          </div>
        </Card>
      </main>
    </div>
  );
}
